import React from "react";
import Component from "components";
import {BlogProvider} from "contexts/blog";
import Banner from "./banner";
import Main from "./main";
import "assets/styles/blog.less"
import data from "./data";

const Project : React.FC = () => {
    return (
        <Component.Publiclayout>
            <Component.Metadecorator
                title={data.meta.title}
                description={data.meta.description}
                imageUrl={data.meta.imageUrl}
                imageAlt={data.meta.imageAlt}
            />
            <div className={"blog-wrapper"}>
                <BlogProvider>
                    <Banner />
                    <Main />
                </BlogProvider>
            </div>
        </Component.Publiclayout>
    )
}

export default Project